// extracted by mini-css-extract-plugin
module.exports = {"header":"final_header__1FWge","main__content":"final_main__content__59TN0","finito":"final_finito__2sT6x","message":"final_message__1rxX9"};